import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const Scholarity = () => {
    const { chartData } = useIdentificationChartsDataContext();


    return (
        <SimpleBars
            title={'Escolaridade'}
            horizontal={true}
            subtitles={chartData?.scholarity?.map((item) => item.description)}
            values={chartData?.scholarity?.map((item) => item.total  ||  0)}
        />
    );
};
